export default function DashboardTier({ dashboard }) {
  return (
    <>
      {dashboard.components_number > 5 && (
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "-35px",
            transform: "rotate(45deg)",
            background: "linear-gradient(135deg, #ffd700 0%, #ffaa00 100%)",
            color: "#333",
            padding: "5px 40px",
            fontSize: "12px",
            fontWeight: "bold",
            textTransform: "uppercase",
            boxShadow: "0 3px 10px rgba(0,0,0,0.3)",
            zIndex: 10,
            letterSpacing: "1px",
          }}
        >
          Premium
        </div>
      )}
      {dashboard.components_number <= 5 && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "-35px",
            transform: "rotate(45deg)",
            background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
            color: "#fff",
            padding: "5px 40px",
            fontSize: "12px",
            fontWeight: "bold",
            textTransform: "uppercase",
            boxShadow: "0 3px 10px rgba(0,0,0,0.3)",
            zIndex: 10,
            letterSpacing: "1px",
          }}
        >
          Free
        </div>
      )}
    </>
  );
}
